import React, { useEffect, useRef } from 'react'

import { init } from './app'
import { hexToObj } from 'src/utils/Color'

const Confetti = ({ impactColors }) => {
  const canvas = useRef()

  useEffect(() => {
    const colors = impactColors
    .filter(({ name }) => ![ 'Brown', 'Black', 'Gray' ].includes(name))
    .map(({ value }) => Object.values(hexToObj(value)))
    return init(canvas.current, { colors })
  }, [])

  return <canvas ref={canvas} className="w-100 h-100" />
}

export default Confetti
